export default "__VITE_ASSET__DMLuY5SQ__"